<template>
  <div class="content">
    <div class="content__wrapper">
      <div class="content__inner">
        <div class="content__left">
          <Tab />
          <Preview ref="preview" />
        </div>
        <div class="content__right">
          <Selectors />
        </div>
        <div class="content__bottom">
          <Buttons @print="print" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from './Tab'
import Preview from './Preview'
import Selectors from './Selectors'
import Buttons from './Buttons'
export default {
  components: {
    Tab,
    Preview,
    Selectors,
    Buttons
  },
  methods: {
    print() {
      this.$refs.preview.print()
    },
  }
}
</script>
